import { v4 as uuid } from 'uuid';

export interface ITaxYearInformationResponse {
  id?: string;
  createdAt?: string;
  taxYear?: number;
  installNumber?: string;
  billingPeriodStart?: string;
  billingPeriodEnd?: string;
  taxesBilledCents?: number;
  taxesPaidCents?: number;
  dueDate?: string;
  status?: string;
}

export interface ITaxYearInformationData {
  id?: string;
  createdAt?: string;
  taxYear?: number;
  installNumber?: string;
  billingPeriodStart?: string;
  billingPeriodEnd?: string;
  taxesBilledCents?: number;
  taxesPaidCents?: number;
  dueDate?: string;
  status?: string;
}

export const createDefaultTaxYearInformationData = (): ITaxYearInformationData =>
  ({
    id: uuid(),
  } as ITaxYearInformationData);

export const convertTaxYearInformationResponseToTaxYearInformationData = (
  res: ITaxYearInformationResponse
): ITaxYearInformationData => ({
  id: res.id,
  createdAt: res.createdAt,
  taxYear: res.taxYear,
  installNumber: res.installNumber,
  billingPeriodStart: res.billingPeriodStart,
  billingPeriodEnd: res.billingPeriodEnd,
  taxesBilledCents: res.taxesBilledCents,
  taxesPaidCents: res.taxesPaidCents,
  dueDate: res.dueDate,
  status: res.status,
});

export const convertTaxYearInformationDataToTaxYearInformationResponse = (
  data: ITaxYearInformationData
): ITaxYearInformationResponse => ({
  id: data.id,
  createdAt: data.createdAt,
  taxYear: data.taxYear,
  installNumber: data.installNumber,
  billingPeriodStart: data.billingPeriodStart,
  billingPeriodEnd: data.billingPeriodEnd,
  taxesBilledCents: data.taxesBilledCents,
  taxesPaidCents: data.taxesPaidCents,
  dueDate: data.dueDate,
  status: data.status,
});
